import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import useInputObject from "../../hooks/useInputObject";
import { Checkbox, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import TRANSACTION_STATE from "./state/TransactionState";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import { getHyphenedDate } from "../../utils/utils";

const infoTableCellSx = {
  fontSize: 17,
};

// 検索フォーム
function SearchForm(props) {
  const { mode, commodityOwners, buyers, searchForm } = props;
  const [buyer, setBuyer] = useState();
  const [commodityOwner, setCommodityOwner] = useState();

  useEffect(() => {
    // if (!buyer && !commodityOwner) return;
    if (mode.Value == TRANSACTION_STATE.RECEIPT) {
      searchForm.update("partnerId", buyer?.buyerNo || "");
    }
    if (mode.Value == TRANSACTION_STATE.PAYMENT) {
      searchForm.update("partnerId", commodityOwner?.commodityOwnerCd || "");
    }
  }, [buyer, commodityOwner]);

  function handleBlurSearch() {
    props.search();
  }

  return (
    <Box
      border="1px solid blue"
      borderRadius={1}
      padding={2}
      onFocus={(e) => e.target.select()}
      onBlur={handleBlurSearch}
    >
      検索条件
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" marginBottom={1} spacing={6}>
          <Grid item xs="auto">
            {mode.Value == TRANSACTION_STATE.PAYMENT ? (
              <CommonAutocomplete
                label="支払い先"
                value={commodityOwner}
                onSelect={(e, newValue) => {
                  setCommodityOwner(newValue);
                }}
                data={commodityOwners}
                filterOptions={(options, { inputValue }) => {
                  inputValue = inputValue.trim();
                  return options.filter(
                    (x) =>
                      x.commodityOwnerCd.toString().startsWith(inputValue) ||
                      x.commodityOwnerName.includes(inputValue)
                  );
                }}
                optionLabel={(option) =>
                  option
                    ? option.commodityOwnerCd +
                      " - " +
                      option.commodityOwnerName
                    : ""
                }
                width={300}
              />
            ) : (
              <CommonAutocomplete
                label="入金元"
                value={buyer || null}
                onSelect={(e, newValue) => {
                  setBuyer(newValue);
                }}
                name="buyerNo"
                data={buyers}
                filterOptions={(options, { inputValue }) => {
                  inputValue = inputValue.trim();
                  return options.filter((x) => {
                    return (
                      x.buyerNo.toString().startsWith(inputValue) ||
                      x.buyerName.includes(inputValue)
                    );
                  });
                }}
                optionLabel={(option) =>
                  option ? option.buyerNo + " - " + option.buyerName : ""
                }
                width={380}
              />
            )}
          </Grid>
          <Grid item xs="auto">
            {/* TargetDate */}
            <TextField
              InputLabelProps={{
                shrink: true,
                style: {
                  fontSize: 20,
                  fontWeight: 500,
                  padding: 0,
                },
              }}
              InputProps={{
                paddingInline: 0,
                inputProps: {
                  min: "1000-01-01",
                  max: "9999-12-31",
                },
                ...props.InputProps,
              }}
              label="対象日"
              type="date"
              value={searchForm.Value.targetDate}
              onChange={(e) => searchForm.update("targetDate", e.target.value)}
            ></TextField>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SearchForm;
